import React from 'react'
import moment from 'moment';
import {getLogisticPricing} from "../../store/action/pricing";
import {isAuthenticated} from "../../store/action/auth";
import {courierWithCoordinates, courierWithCOD} from "./courier";

export const normalizeMarketPlaceFile = async (name,file) => {
    let items = 0;
    let price = 0;
    let orders;
    if (name === 'orders') {
        orders = await file.reduce(async (rP, i, idx) => {
            const r = await rP;
            let orderItems = [];
            let itemsLeft = file.length - idx;

            for (let j = 0; j < itemsLeft; j++) {
                let fl = file[idx+j];
                if (fl["Order Number"] && j > 0) {
                    break
                }
                let item = {
                    name: fl["Item Name"],
                    quantity: 1,
                    length: fl["Item Length (cm)"],
                    width: fl["Item Width (cm)"],
                    height:fl["Item Height (cm)"],
                    value: fl["Item Value (IDR)"],
                    weight: fl["Item Weight (gram)"]
                };
                orderItems.push(item);
            }

            if (i["Order Number"]) {
                const originPostalCode = i["Sender Postal Code"];
                const destinationPostalCode = i["Receiver Postal Code"];
                const courierCompany = i["Courier Company"];
                const courierType = i["Courier Service"];
                let originMap = "empty";
                let receiverMap = "empty";
                let price = null;
                let receiverCODAmount = 0;
                let error = false;
                let paymentMethod = i["Payment Method"];

                if (!courierWithCoordinates(courierCompany)) {
                    let res = await getLogisticPricing(
                        isAuthenticated().token,
                        originPostalCode,
                        destinationPostalCode,
                        orderItems,
                        `${courierCompany}_${courierType}`,
                        'postalCode'
                    );
                    if (res.success) {
                        originMap = "filled";
                        receiverMap = "filled";
                        price = res.pricing[0].price;
                    } else {
                        error = true
                    }
                }

                if (courierWithCOD(courierCompany) && i["Cash On Delivery Value"] > 0) {
                    receiverCODAmount = i["Cash On Delivery Value"]
                } else {
                    paymentMethod = 'online'
                }

                r.push({
                    deliveryDate: moment().format("YYYY-MM-DD"),
                    deliveryTime: moment().format("HH:mm"),
                    deliveryType: 'later',
                    deliveryNote: '-',
                    error:error,
                    waybillId: null,
                    originName: i["Sender Name"],
                    originLocation: i["Sender Address"],
                    originInputLocation: "",
                    originPhone: i["Sender Mobile Number"],
                    originNote: i["Sender Location Details (Optional)"],
                    originPostalCode: originPostalCode,
                    originLatitude:null,
                    originLongitude:null,
                    originMap: originMap,
                    receiverName:i["Receiver Name"],
                    receiverLocation: i["Receiver Address"],
                    receiverInputLocation: "",
                    receiverPhone: i["Receiver Mobile Number"],
                    receiverNote: i["Receiver Location Details (Optional)"],
                    receiverPostalCode: destinationPostalCode,
                    receiverLatitude:null,
                    receiverLongitude:null,
                    receiverMap: receiverMap,
                    receiverCODAmount: receiverCODAmount,
                    courierCompany: courierCompany,
                    courierType: courierType,
                    courierName: '-',
                    courierPhone: '-',
                    courierStatus: '-',
                    courierLink: '-',
                    orderNote: i["Note"],
                    tags: i["Tags"] ? i["Tags"].split(",") : [],
                    items: orderItems,
                    paymentType: paymentMethod,
                    price:price,
                    status: 'placed',
                    loading:false
                });
            }
            return r
        }, Promise.resolve([]))
    } else {
        orders = await file.reduce((r, i, idx) => {
            let orderItems = [];
            let itemsLeft = file.length - idx;

            for (let j = 0; j < itemsLeft; j++) {
                let fl = file[idx+j];
                if (fl.order_no && j > 0) {
                    break
                }
                let item = {
                    name: fl.product_name,
                    value: fl.product_value,
                    length: fl.product_length,
                    width: fl.product_width,
                    height: fl.product_height,
                    sku: fl.product_sku,
                    quantity: fl.product_quantity,
                    weight: fl.product_weight
                };
                orderItems.push(item);
            }
            if (i.order_no) {
                r.push({
                    userId: i.user_id,
                    bulkOrderId: i.bulk_order_id,
                    courierName: i.courier_driver_name || null,
                    courierPhone: i.courier_driver_phone || null,
                    courierCompany: i.courier_company,
                    courierType: i.courier_service_type,
                    courierStatus: i.status,
                    courierLink: '-',
                    courierShipmentFee:i.shipment_fee,
                    deliveryDate: i.delivery_date,
                    deliveryTime: i.delivery_time,
                    deliveryType: 'later',
                    deliveryNote: i.delivery_note || null,
                    waybillId: i.waybill_id,
                    originName: i.origin_name,
                    originLocation: i.origin_address,
                    originPhone: i.origin_phone,
                    originEmail: i.origin_email,
                    originNote:i.origin_note || null,
                    originPostalCode: i.origin_postal_code,
                    receiverName: i.receiver_name,
                    receiverLocation: i.receiver_address,
                    receiverPhone: i.receiver_phone,
                    receiverEmail: i.receiver_email,
                    receiverNote: i.receiver_note || null,
                    receiverPostalCode: i.receiver_postal_code,
                    note: i.order_note,
                    items: orderItems,
                    paymentType: 'online',
                    price:i.shipment_fee,
                    status: i.status
                });
            }
            return r
        },[]);
    }

    return {
        success:true,
        orders,
        items,
        price
    }
};
